/** Represents expression kinds.*/
export var DataKind;
(function (DataKind) {
    /** Represents one value of some type: one constant or one attribute (field).*/
    DataKind[DataKind["Scalar"] = 0] = "Scalar";
    /** The same as Scalar but represents only one constant value of some type.*/
    DataKind[DataKind["Const"] = 1] = "Const";
    /** The same as Scalar but represents only one attribute.*/
    DataKind[DataKind["Attribute"] = 2] = "Attribute";
    /** Represents a list of scalar values. */
    DataKind[DataKind["List"] = 4] = "List";
    /** Special expression kind which represents a sub query.*/
    DataKind[DataKind["Query"] = 5] = "Query";
    /** Special expression kind which represents a binding to parent column.*/
    DataKind[DataKind["ParentColumn"] = 6] = "ParentColumn";
})(DataKind || (DataKind = {}));
//# sourceMappingURL=data_kind.js.map